/* istanbul ignore file */
import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconMusicNotes({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='music-notes_svg__c'>
            <path d='M0 14h10v9.293H0Zm0 0' />
          </clipPath>
          <clipPath id='music-notes_svg__d'>
            <path d='M14 12h9.98v9H14Zm0 0' />
          </clipPath>
          <clipPath id='music-notes_svg__e'>
            <path d='M0 .707h23.98v22.586H0Zm0 0' />
          </clipPath>
          <clipPath id='music-notes_svg__b'>
            <path d='M0 0h24v24H0z' />
          </clipPath>
          <clipPath id='music-notes_svg__h'>
            <path d='M7 4h16.98v5H7Zm0 0' />
          </clipPath>
          <filter
            id='music-notes_svg__a'
            width='100%'
            height='100%'
            x='0%'
            y='0%'
            filterUnits='objectBoundingBox'
          >
            <feColorMatrix
              in='SourceGraphic'
              values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
            />
          </filter>
          <mask id='music-notes_svg__g'>
            <g filter='url(#music-notes_svg__a)'>
              <path fillOpacity={0.99} d='M0 0h24v24H0z' />
            </g>
          </mask>
          <g id='music-notes_svg__f' clipPath='url(#music-notes_svg__b)'>
            <path
              fill='none'
              stroke='currentColor'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={1.011}
              d='M5.714 13.26V3.762c0-.354.125-.697.354-.966a1.48 1.48 0 0 1 .893-.509l6.786-1.131a1.48 1.48 0 0 1 1.214.334 1.5 1.5 0 0 1 .529 1.143v8.993'
              transform='scale(1.5 1.41176)'
            />
          </g>
        </defs>
        <g clipPath='url(#music-notes_svg__c)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.011}
            d='M3.107 15.868a2.61 2.61 0 0 0 0-5.218 2.61 2.61 0 0 0 0 5.218m0 0'
            transform='scale(1.5 1.41176)'
          />
        </g>
        <g clipPath='url(#music-notes_svg__d)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.011}
            d='M12.88 14.236a2.61 2.61 0 0 0 0-5.219 2.609 2.609 0 0 0 0 5.218m0 0'
            transform='scale(1.5 1.41176)'
          />
        </g>
        <g clipPath='url(#music-notes_svg__e)'>
          <use
            xlinkHref='#music-notes_svg__f'
            mask='url(#music-notes_svg__g)'
          />
        </g>
        <g clipPath='url(#music-notes_svg__h)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.011}
            d='m5.714 5.431 9.776-1.63'
            transform='scale(1.5 1.41176)'
          />
        </g>
      </svg>
    </>
  )
}
IconMusicNotes.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconMusicNotes
